import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import SplitFlapText from "../common/SplitFlapText";

interface StatCardProps {
  value: string;
  label: string;
}

const StatCard: React.FC<StatCardProps> = ({ value, label }) => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.up("md"));

  let labelVariant: "h6" | "body1" | "body2" = "body2";

  if (isLarge) labelVariant = "h6";
  else if (isMedium) labelVariant = "body1";
  else labelVariant = "body2";

  return (
    <Box
      sx={{
        p: 2,
        textAlign: "center",
        alignContent: "center",
        boxShadow: 3,
        minHeight: { sx: 150, sm: 150, md: 180 },
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        border: `1px solid ${theme.palette.text.disabled}`,
      }}
    >
      {/* Efecto SplitFlap de avión */}
      <SplitFlapText value={value} />

      <Typography variant={labelVariant} sx={{ mt: 1, fontWeight: "bold" }}>
        {label}
      </Typography>
    </Box>
  );
};

export default StatCard;
